// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3P79W","title":"FrontImage_title__2XvVU"};